import React from 'react';

const TabNavigation = ({ activeTab, onTabChange }) => {
  const tabs = [
    { key: "dailyJobs", label: "Daily Jobs" },
    { key: "reports", label: "Reports" },
    { key: "expenses", label: "Expenses" },
    { key: "estimator", label: "Estimator" },
    { key: "customers", label: "Customers" },
    { key: "emailList", label: "Email List" }
  ];

  return (
    <div className="mb-6 sm:mb-8 -mx-4 sm:mx-0 px-4 sm:px-0">
      <div className="border-b border-secondary-200 overflow-x-auto scrollbar-hide">
        <nav className="-mb-px flex gap-0 min-w-max sm:min-w-0 sm:flex-wrap">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => onTabChange(tab.key)}
              className={`py-3 px-4 sm:py-4 sm:px-1 sm:mr-6 border-b-2 font-medium text-sm whitespace-nowrap transition-all duration-200 touch-manipulation min-h-[44px] ${
                activeTab === tab.key
                  ? "border-primary-500 text-primary-600"
                  : "border-transparent text-secondary-500 hover:text-secondary-700 hover:border-secondary-300"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default TabNavigation;